import {
  LOGOUT,
  O365_REGISTER_SUCCESS,
  BSRS_LOGIN_SUCCESS,
  BSRS_SERVICE_TOKEN_SUCCESS
} from '../../types'

import { getAllToken, getUserInfo, getBSRSToken, getServiceToken } from 'Lib'

const allToken = getAllToken()
const { bsrsToken } = getBSRSToken()
const serviceToken = getServiceToken()

const initialState = {
  token: allToken,
  bsrsToken,
  user: getUserInfo(allToken.access_token),
  serviceToken
}

export default (state = initialState, action) => {
  switch (action.type) {
    case O365_REGISTER_SUCCESS: {
      return {
        ...state,
        token: {
          ...action.payload.token
        },
        user: getUserInfo(action.payload.token.access_token)
      }
    }
    case BSRS_LOGIN_SUCCESS: {
      return {
        ...state,
        bsrsToken: action.payload.bsrsToken,
        isAdmin: action.payload.role,
        user: action.payload.data
      }
    }
    case BSRS_SERVICE_TOKEN_SUCCESS: {
      return {
        ...state,
        bsrsToken: action.payload.bsrsToken,
        serviceToken: action.payload.serviceToken
      }
    }
    case LOGOUT:
      return {
        ...state,
        bsrsToken: undefined
      }
    default:
      return state
  }
}


// WEBPACK FOOTER //
// ./src/features/auth/reducer.js